export const dispatchElementEvent = (selector: string, eventName: string, detail?: any) => {
  const element = document.querySelector(selector);
  if (!element) return;
  element.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export class ElementEvent {
  constructor(private selector: string) {}
  dispatch = (eventName: string, detail?: any) => {
    dispatchElementEvent(this.selector, eventName, detail);
  };
  on = (eventName: string, callback: (event: CustomEvent, dispatch: typeof dispatchElementEvent) => void) => {
    const element = document.querySelector(this.selector);
    if (!element) return;
    element.addEventListener(eventName, (event) => callback(event as CustomEvent, dispatchElementEvent));
  };
}

export class DOM {
  get = <T extends Element>(selector: string) => {
    const element = document.querySelector(selector) as T;
    return {
      element,
      on: element.addEventListener.bind(element),
      dispatch: (eventName: string, detail?: any) => dispatchElementEvent(selector, eventName, detail)
    };
  };
}
